import React from "react";
import { connect } from "react-redux";
// components
import GroupView from "../components/GroupView";
import withUrlSortParam from "../components/withUrlSortParam";
// actions, helpers + selectors
import { fetchActiveFavourites, fetchGooutELPResourcesWithoutPopular, fetchMonuments, toggleExploreMenu } from "../actions/index";
import { capitalizeFirstLetter, replaceCityAndTimePlaceholder } from "../helpers/constants";
import { getCardCountForGroupAndCategory, getTypeFilteredCardCountForGroupAndCategory, getCategoryNameFromSlug, getGroupName, getSelectedCity, getSelectedCityName, getSEODetailsForGroupAndCity, isUserLoggedIn, getCategoryTitle, getCardsForGroupAndCity, getShowFiltersForGroup } from "../selectors/index";
import { hasFetchedFavouriteEvents, isFetchingFavouritesData } from "../selectors/favourites";
import { getAllCitiesForGroup } from "../selectors";
import { getMonumentsDataReceived, getMonumentsDataRequested, getELPDataReceived, getELPDataRequested } from "../selectors/elp";
import { withRouter } from "react-router";
const mapStateToProps = (state, props) => {
    const seoDetails = getSEODetailsForGroupAndCity(state, props);
    const city = getSelectedCityName(state);
    let title = seoDetails.get("title");
    const cardCount = getCardCountForGroupAndCategory(state, props);
    const groupName = getGroupName(state, props);
    if (props.category) {
        const category = getCategoryNameFromSlug(state, props);
        if (category) {
            const backendSEOForCategory = getCategoryTitle(state, category);
            if (backendSEOForCategory) {
                title = replaceCityAndTimePlaceholder(backendSEOForCategory, city, props.timeFilter, cardCount);
            }
            else {
                title = `Best Upcoming ${category} Events & Shows in ${city} | Explore & Buy tickets online`;
            }
        }
    }
    let stateProps = {
        elpDataRequested: getELPDataRequested(state),
        elpDataReceived: getELPDataReceived(state),
        monumentsDataRequested: getMonumentsDataRequested(state),
        monumentsDataReceived: getMonumentsDataReceived(state),
        allowFavouriting: true,
        cardCount,
        eventTypeCardCount: getTypeFilteredCardCountForGroupAndCategory(state, props),
        description: seoDetails.get("description"),
        displayTitle: props.category ? getCategoryNameFromSlug(state, props) : seoDetails.get("displayTitle"),
        favouritesFetched: hasFetchedFavouriteEvents(state),
        groupName,
        isFetchingFavourites: isFetchingFavouritesData(state),
        isLoggedIn: isUserLoggedIn(state),
        selectedCity: city,
        title,
        showFilter: getShowFiltersForGroup(state, props)
    };
    if (groupName === "Monuments") {
        stateProps["monumentCities"] = getAllCitiesForGroup(state, props);
    }
    return stateProps;
};
const mapDispatchToProps = dispatch => ({
    getELPData: city => dispatch(fetchGooutELPResourcesWithoutPopular(city)),
    fetchActiveFavourites: () => dispatch(fetchActiveFavourites()),
    toggleExploreMenu: () => dispatch(toggleExploreMenu()),
    fetchMonuments: () => dispatch(fetchMonuments())
});
const GroupViewWithSubscription = withRouter(withUrlSortParam(connect(mapStateToProps, mapDispatchToProps)(GroupView)));
// set static on this component
// for its preload chunk
GroupViewWithSubscription.preloadChunkName = "GroupPage";
// Add a static fetch data for SSR
GroupViewWithSubscription.fetchData = ({ location, store, city }) => {
    let dispatchArr = [store.dispatch(fetchGooutELPResourcesWithoutPopular(city))];
    if (location.pathname && location.pathname.includes(`monuments`)) {
        dispatchArr.push(store.dispatch(fetchMonuments()));
    }
    return Promise.all(dispatchArr);
};
export default GroupViewWithSubscription;
